import type { CSSProperties, ReactNode } from "react";
import "./_stylized-icon.scss";

export type StylizedIconProps = {
  primaryColor: string;
  secondaryColor: string;
  icon?: ReactNode;
  className?: string;
};

export default function StylizedIcon({
  primaryColor,
  secondaryColor,
  icon,
  className = "",
}: StylizedIconProps) {
  return (
    <span
      className={`stylized-icon ${className}`}
      style={
        {
          "--stylized-icon-primary": primaryColor,
          "--stylized-icon-secondary": secondaryColor,
        } as CSSProperties
      }
      aria-hidden="true"
    >
      {icon ?? <span className="stylized-icon__dot" />}
    </span>
  );
}
